/**
 * Pay Service
 * API calls for pay summary and calculations
 */

import { api } from './api';

export interface PayCalculation {
  totalHours: number;
  regularHours: number;
  overtimeHours: number;
  shortNoticeHours: number;
  regularPay: number;
  overtimePay: number;
  shortNoticePay: number;
  totalPay: number;
}

export interface FlightSummary {
  id: number;
  flightDate: string;
  tailNumber: string;
  logsheetNumber: string;
  qNumber: string;
  airTime: number;
  flightTime: number;
  isShortNotice: boolean;
  notes?: string;
}

export interface MonthlySummary extends PayCalculation {
  userId: number;
  year: number;
  month: number;
  totalFlights: number;
  totalAirTime: number;
  totalFlightTime: number;
  flights: FlightSummary[];
}

/**
 * Get monthly flight summary with pay calculation
 */
export async function getMonthlySummary(
  userId: number,
  year: number,
  month: number
): Promise<MonthlySummary> {
  const result = await api.get<{ success: boolean; data: MonthlySummary }>(
    `/flights/summary/${userId}/${year}/${month}`
  );
  return result.data;
}

/**
 * Get pay calculation for date range
 */
export async function getPayCalculation(
  userId: number,
  startDate: string,
  endDate: string
): Promise<PayCalculation> {
  const result = await api.get<{ success: boolean; data: PayCalculation }>(
    `/flights/pay/${userId}?startDate=${startDate}&endDate=${endDate}`
  );
  return result.data;
}
